var map = {
	"./ar.json": 925,
	"./de.json": 873,
	"./en.json": 53,
	"./es.json": 406,
	"./fr.json": 222,
	"./hi.json": 249,
	"./id.json": 999,
	"./it.json": 767,
	"./ja.json": 83,
	"./pt.json": 34,
	"./ro.json": 489,
	"./sk.json": 272,
	"./zh.json": 816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 815;